import { getTranslation } from 'helpers/getTranslation';

export const getMenuItems = () => {
  return [
    {
      key: 'analytics',
      icon: 'dashboard',
      text: getTranslation('components.sidebar.menu.analytics'),
      to: '/analytics',
    },
    {
      key: 'dashboard',
      icon: 'dashboard',
      text: getTranslation('components.sidebar.menu.dashboard'),
      to: '/dashboard',
    },
    {
      key: 'learningPath',
      icon: 'courses',
      text: getTranslation('components.sidebar.menu.learning_path'),
      to: '/learning-path',
    },
    {
      key: 'courses',
      icon: 'courses',
      text: getTranslation('components.sidebar.menu.courses'),
      to: '/courses',
    },
    {
      key: 'coursesLessons',
      icon: 'lessons',
      text: getTranslation('components.sidebar.menu.courses_lessons'),
      to: '/courses-lessons',
    },
    {
      key: 'dailyChallenges',
      icon: 'trainings',
      text: getTranslation('components.sidebar.menu.daily_challenges'),
      to: '/daily-challenges',
    },
    {
      key: 'trainings',
      icon: 'trainings',
      text: getTranslation('components.sidebar.menu.trainings'),
      to: '/trainings',
    },
    {
      key: 'arcades',
      icon: 'arcades',
      text: getTranslation('components.sidebar.menu.arcades'),
      to: '/arcades',
    },
    {
      key: 'lessonCategories',
      icon: 'quiz',
      text: getTranslation('components.sidebar.menu.lesson_categories'),
      to: '/lesson-categories',
    },
    {
      key: 'lessons',
      icon: 'lessons',
      text: getTranslation('components.sidebar.menu.lessons'),
      to: '/lessons',
    },
    {
      key: 'employees',
      icon: 'admins',
      text: getTranslation('components.sidebar.menu.admins'),
      to: '/admins',
    },
    {
      key: 'students',
      icon: 'students',
      text: getTranslation('components.sidebar.menu.students'),
      to: '/students',
    },
    {
      key: 'schools',
      icon: 'schools',
      text: getTranslation('components.sidebar.menu.schools'),
      to: '/schools',
    },
    {
      key: 'school',
      icon: 'schools',
      text: getTranslation('components.sidebar.menu.school'),
      to: '/school-profile',
    },
    {
      key: 'inbox',
      icon: 'mail',
      text: getTranslation('components.sidebar.menu.inbox'),
      to: '/inbox',
    },
  ];
};
